import AuthApi from '@apis/auth/AuthApi';
import queries from '@apis/queries';
import { useFlow } from '@stackflow/react';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useCookies } from 'react-cookie';

function useLogout() {
    const setSidebarOpen = useSetAtom(isSidebarOpenAtom);
    const [cookies, __, removeCookie] = useCookies(['accessToken', 'refreshToken']);
    const { pop } = useFlow();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: AuthApi.signOut,
        onSettled() {
            setSidebarOpen(false);
            removeCookie('refreshToken', { path: '/' });
            removeCookie('accessToken', { path: '/' });
            pop(4);
            queryClient.resetQueries({ queryKey: queries.user.profile._def });
        },
    });
    return () => {
        const { refreshToken } = cookies;
        mutate(refreshToken);
    };
}

export default useLogout;
